// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"379":"a0424bbe","522":"fb06d735","600":"af9964e3","747":"d806e0bb"}[chunkId] + ".chunk.css";
};